'use client';

export default function useWhatsappMessage() {
  const sendMessage = ({ phone, message = "", type = "anchor", windowOpenType = "_blank" }) => {
    const url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}&phone=${phone}`;

    if(type === "anchor") {
      return url
    } else {
      window.open(url, windowOpenType);
    }
  }

  return {
    sendMessage
  };
}
